module.exports = __webpack_public_path__ + "img/TT_Darts_LP.826b8f04.jpg";